export const mainColor = '#181418';
export const primaryColor = '#F25018';

export const services = {
  sales: '#F25018',
  innovation: '#33DFFF',
  funding: '#1832AB',
};
